module.exports = __webpack_public_path__ + "icon_bank_account.svg?acaf0aeb757596f7ee5b554f9b9106e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bank_account.svg
// module id = 61
// module chunks = 0